import RootLayoutModule from './RootLayoutModule'

export default RootLayoutModule
